import { pingback } from '@giphy/js-analytics'
import { IUser } from '@giphy/js-types'
import { map } from 'lodash'
import React, { useEffect, useState } from 'react'
import { InView } from 'react-intersection-observer'
import { fetchRelatedKeywords } from 'shared/api/index'
import Tag from 'shared/components/tags/simple-tag'

type Props = {
    term: string
    css: any
    isSticker: boolean
    isMobile: boolean
    user: IUser
    responseId: string
}
type Term = {
    name: string
    analytics_response_payload: string
    response_id?: string
}

const SuggestedTerms = ({ css, isSticker, user, responseId, term }: Props) => {
    const [terms, setTerms] = useState<Term[]>([])
    const getTerms = async () => {
        try {
            const { data: suggestedTerms } = await fetchRelatedKeywords(term, false)
            setTerms(suggestedTerms)
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getTerms()
    }, [])

    const googleAnalytics = {
        category: 'Search',
        action: 'Related Tag Click	',
    }
    if (!terms.length) return <div className={css.sparseTermState} />

    return (
        <div className={css.termSuggestionContainer}>
            <div className={css.suggestions}>
                {map(terms, (item: Term, index) => (
                    <InView
                        as="span"
                        key={index}
                        triggerOnce
                        threshold={1}
                        onChange={inView => {
                            if (inView) {
                                pingback({
                                    userId: user.id,
                                    actionType: 'SEEN',
                                    attributes: {
                                        search_response_id: responseId,
                                    },
                                    analyticsResponsePayload: item.analytics_response_payload,
                                })
                            }
                        }}
                    >
                        <Tag
                            name={item.name}
                            isSticker={isSticker}
                            analytics={googleAnalytics}
                            onClick={() => {
                                pingback({
                                    userId: user.id,
                                    actionType: 'CLICK',
                                    attributes: {
                                        search_response_id: responseId,
                                    },
                                    analyticsResponsePayload: item.analytics_response_payload,
                                })
                            }}
                            onHover={() => {
                                pingback({
                                    userId: user.id,
                                    actionType: 'HOVER',
                                    attributes: {
                                        search_response_id: responseId,
                                    },
                                    analyticsResponsePayload: item.analytics_response_payload,
                                })
                            }}
                        />
                    </InView>
                ))}
            </div>
        </div>
    )
}
export default SuggestedTerms
